import { render, staticRenderFns } from "./AmountPanel.vue?vue&type=template&id=1511169a&scoped=true&"
import script from "./AmountPanel.vue?vue&type=script&lang=js&"
export * from "./AmountPanel.vue?vue&type=script&lang=js&"
import style0 from "./AmountPanel.vue?vue&type=style&index=0&id=1511169a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511169a",
  null
  
)

export default component.exports